var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from '@angular/core';
import { Headers, Http, RequestOptions, ResponseContentType } from '@angular/http';
import { NotificationsService } from 'angular2-notifications';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { CountryPhoneNumberFormats } from '../../common/constants/country-phonenumber-format.constants';
import { DiscountTypeConstants } from '../../common/constants/dispute-type.constants';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { MemberPreferenceType } from '../../common/enums/member-preference.enum';
import { Permission } from '../../common/enums/permission.enum';
import { PreferenceValues } from '../../common/enums/preference-value.enum';
import { Constants } from '../../customerservice/common/constants';
import { MemberLevel, OrderType, PromotionActionType } from '../../customerservice/common/enumerations';
import { DiscountType } from '../../customerservice/enums/discount-type.enum';
import { MemberTypeEnum } from '../../customerservice/enums/member-type.enum';
import { NotificationType } from '../../customerservice/enums/notification-types.enum';
import { PaymentMethodTypes, PurchaseFlows } from '../../customerservice/enums/order-source-type';
import { PriceTier, PriceTierMemberType } from '../../customerservice/enums/price-tier.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CacheService } from '../../shared/services/cache.service';
import { MemberActivityLogPortal } from '../common/enumerations';
import { CommonConstant } from '../constants/common.constants';
import { environment } from './../../../environments/environment';
import { ImageType } from '../../customerservice/enums/image-type.enum';
import { StockQuantity } from '../../customerservice/interface/stock-quantity';
import { AppConfigService } from '../../customerservice/services/app-config.service';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators';
import { UserTitleType } from '../../customerservice/common/constants';
import { MemberPreferencesType } from '../../customerservice/enums/member-preferences.enum';
import { PaymentMethodTypeConstants } from '../../customerservice/constants/payment-method-types.constants';
import { PromotionRewardTypeEnum } from '../../customerservice/enums/promotion-reward-type.enum';
var CommonService = /** @class */ (function () {
    function CommonService(_http, _cacheService, _notificationService, appConfigService) {
        var _this = this;
        this._http = _http;
        this._cacheService = _cacheService;
        this._notificationService = _notificationService;
        this.appConfigService = appConfigService;
        this.downlineUrl = environment.uiTemplateBaseUrl +
            '/test/downline.json';
        this._languages = environment.uiTemplateBaseUrl +
            '/test/language.json';
        this._appSideMenuBar = environment.uiTemplateBaseUrl +
            '/test/app-side-menu-bar.json';
        this.routePermissionURL = environment.uiTemplateBaseUrl + '/test/route-permission.json';
        this._personaliInfoFormValidation = environment.cdnURL + '/portals/customercare/template1/schema-forms/';
        //Collection of EventEmitter object;
        this._eventEmitters = {};
        /**
         *
         *
         * @memberof CommonService
         */
        this.getMemberActivityLogs = function (requestPayload) {
            var url = ApiUrlConstants.auditApiUrl + 'members/' + requestPayload.memberId + '/activitylogs?';
            if (requestPayload.sortBy) {
                url = url + '&sortBy=' + requestPayload.sortBy;
            }
            if (requestPayload.sortOrder) {
                url = url + '&sortOrder=' + requestPayload.sortOrder;
            }
            if (requestPayload.pageNumber) {
                url = url + '&pageNo=' + requestPayload.pageNumber;
            }
            if (requestPayload.pageSize) {
                url = url + '&pageSize=' + requestPayload.pageSize;
            }
            return _this._http
                .get(url)
                .map(function (res) { return res.json(); })
                .catch(_this.handleErrorObservable);
        };
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    }
    /**
     * Create a singleton EventEmitter Object
     *  for a given Id
     * @param Id {String}
     * @returns eventEmitter {EventEmitter}
     * */
    CommonService.prototype.getEmitter = function (id) {
        if (this._eventEmitters[id] === undefined) {
            this._eventEmitters[id] = new EventEmitter();
        }
        return this._eventEmitters[id];
    };
    /**
     * To get all configurations
     * @returns Observable
     */
    CommonService.prototype.getConfiguration = function (countryName) {
        var baseUrl = process.env.ENV === 'production' ? environment.baseHref : 'http://shop.dev.flptitan.com/';
        return this._http.
            get(baseUrl + 'api/Configuration?countryName=' + countryName)
            .map(function (res) { return res.json(); });
    };
    /**
     * @param  {number} userId
     * @returns Observable
     */
    CommonService.prototype.getDownline = function (userId) {
        return this._http.get(this.downlineUrl).map(function (res) { return res.json(); });
    };
    CommonService.prototype.getLanguages = function () {
        return this._http.get(this._languages).map(function (res) { return res.json(); });
    };
    /**
     * to get static side menu bar
     * @returns Observable
     */
    CommonService.prototype.getSideMenuBar = function () {
        return this._http.get(this._appSideMenuBar).map(function (res) { return res.json(); });
    };
    CommonService.prototype.checkPermissionList = function (value, isStore, storeId) {
        if (value instanceof Array) {
            if (this.userInfo && this.userInfo.hasSystemRole) {
                return true;
            }
            else if (isStore && storeId && storeId > 0) {
                var manageStorePermissions = [Permission.MANAGE_STORE_CREATE, Permission.MANAGE_STORE_VIEW, Permission.MANAGE_STORE_EDIT, Permission.MANAGE_STORE_DELETE];
                var userStorePermissions = this.userInfo.privileges.stores;
                var userAccountPermissions = this.userInfo.privileges.account;
                if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(function (item) { return value.indexOf(item) >= 0; })) {
                    return true;
                }
                else if (userStorePermissions && userStorePermissions.length > 0) {
                    var store = userStorePermissions.filter(function (item) { return item.id === storeId; })[0];
                    if (store) {
                        return store.permissions.some(function (item) { return value.indexOf(item) >= 0; });
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            else {
                if (this.userInfo && this.userInfo.privileges) {
                    var userAccountPermissions = this.userInfo.privileges.account;
                    if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(function (item) { return value.indexOf(item) >= 0; })) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }
        }
        else {
            return false;
        }
    };
    CommonService.prototype.checkPermissionByAccessLevel = function (value, resourceTypeId, resourceId) {
        var userInfo = this._cacheService.get(CacheKey.UserInfo);
        if ((value instanceof Array) && userInfo) {
            if (userInfo && userInfo.hasSystemRole) {
                return true;
            }
            else {
                return this.validateAccessLevelpermissions(userInfo, value, resourceTypeId, resourceId);
            }
        }
        else {
            return false;
        }
    };
    CommonService.prototype.validateAccessLevelpermissions = function (userInfo, value, resourceTypeId, resourceId) {
        var isAllowed = false;
        switch (resourceTypeId) {
            case AccessLevel.Account: {
                var userAccountPermissions = userInfo.privileges.account;
                if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(function (item) { return value.indexOf(item) >= 0; })) {
                    isAllowed = true;
                }
                break;
            }
            case AccessLevel.Customer_Service: {
                var userCSPermissions = userInfo.privileges.customerService;
                if (userCSPermissions && userCSPermissions.length > 0 && userCSPermissions.some(function (item) { return value.indexOf(item) >= 0; })) {
                    isAllowed = true;
                }
                break;
            }
            case AccessLevel.Department: {
                var userdeparmentPermissions = userInfo.privileges.departments;
                if (resourceId > 0 && userdeparmentPermissions && userdeparmentPermissions.length > 0) {
                    var department = userdeparmentPermissions.filter(function (item) { return item.id === resourceId; })[0];
                    if (department) {
                        isAllowed = department.permissions.some(function (item) { return value.indexOf(item) >= 0; });
                    }
                }
                break;
            }
            case AccessLevel.Store: {
                var userStorePermissions = userInfo.privileges.stores;
                var userAccountPermissions = userInfo.privileges.account;
                if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(function (item) { return value.indexOf(item) >= 0; })) {
                    isAllowed = true;
                }
                else if (resourceId > 0 && userStorePermissions && userStorePermissions.length > 0) {
                    var store = userStorePermissions.filter(function (item) { return item.id === resourceId; })[0];
                    if (store) {
                        isAllowed = store.permissions.some(function (item) { return value.indexOf(item) >= 0; });
                    }
                }
                break;
            }
            case AccessLevel.CMS: {
                var userCMSPermissions = userInfo.privileges.cms;
                if (userCMSPermissions && userCMSPermissions.length > 0 && userCMSPermissions.some(function (item) { return value.indexOf(item) >= 0; })) {
                    isAllowed = true;
                }
                break;
            }
            default: {
                isAllowed = false;
                break;
            }
        }
        return isAllowed;
    };
    /**
      * Personal percentage based on UserTitleType
      * @param  {string} titleType
      * @returns break
      */
    CommonService.prototype.getPersonalDiscount = function (memberTitleId) {
        var discountPercenatge = 0;
        switch (memberTitleId) {
            case MemberLevel.ASSISTANTSUPERVISOR:
                discountPercenatge = 5;
                break;
            case MemberLevel.SUPERVISOR:
                discountPercenatge = 8;
                break;
            case MemberLevel.ASSISTANTMANAGER:
                discountPercenatge = 13;
                break;
            case MemberLevel.MANAGER:
            case MemberLevel.DIAMONDMANAGER:
            case MemberLevel.UNRECOGNIZEDMANAGER:
            case MemberLevel.RECOGNIZEDMANAGER:
            case MemberLevel.SENIORMANAGER:
            case MemberLevel.SOARINGMANAGER:
            case MemberLevel.SAPPHIREMANAGER:
            case MemberLevel.DIAMONDSAPPHIREMANAGER:
            case MemberLevel.DOUBLEDIAMONDMANAGER:
            case MemberLevel.TRIPLEDIAMONDMANAGER:
            case MemberLevel.DIAMONDCENTURIONMANAGER:
                discountPercenatge = 18;
                break;
            default:
                break;
        }
        return discountPercenatge;
    };
    /**
  * @param {string} title
  * @param {string} content
  * @param {string} messageType
  */
    CommonService.prototype.createNotification = function (title, content, messageType, timeOut, messageId) {
        var notificationOptions = {
            id: messageId,
            timeOut: (timeOut >= 0 && timeOut !== null) ? timeOut : 0,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            clickIconToClose: true,
            icons: this.getIcons()
        };
        var htmlTemplate = this.getNotificationTemplate(title, content);
        var type = this.getNotificationType(messageType);
        return this._notificationService.html(htmlTemplate, type, notificationOptions);
    };
    /**
     * @description to get Products tax inclusive total
     * @author Akhil
     * @date 2022-02-09
     * @param {any[]} products
     * @param {number} subTotal
     * @param {*} store
     * @returns
     * @memberof CommonService
     */
    CommonService.prototype.getProductsTotalTax = function (products, subTotal, store) {
        if (products && products.length && subTotal && store) {
            var totaltax = 0;
            for (var _i = 0, products_1 = products; _i < products_1.length; _i++) {
                var item = products_1[_i];
                if (item.taxAmount) {
                    totaltax = totaltax + Number((item.taxAmount).toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
                }
            }
            if (totaltax) {
                return Number((totaltax + subTotal).toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2))));
            }
            return subTotal;
        }
        return 0;
    };
    /**
     * @description
     * @date 2020-04-15
     * @memberof CommonService
     */
    CommonService.prototype.removeNotification = function (messageId) {
        this._notificationService.remove(messageId);
    };
    CommonService.prototype.setNotification = function (title, content, messageType, timeOut, clickOnClose, maxLength) {
        var notificationOptions = {
            timeOut: (timeOut >= 0 && timeOut !== null) ? timeOut : 0,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: !!clickOnClose,
            clickIconToClose: true,
            icons: this.getIcons(),
            maxLength: maxLength || 0
        };
        var htmlTemplate = this.getNotificationTemplate(title, content);
        var type = this.getNotificationType(messageType);
        this._notificationService.html(htmlTemplate, type, notificationOptions);
    };
    CommonService.prototype.getIcons = function () {
        return {
            'success': '<i class="fa fa-times-circle" ></i>',
            'warn': '<i class="fa fa-times-circle" ></i>',
            'error': '<i class="fa fa-times-circle" ></i>',
            'alert': '<i class="fa fa-times-circle" ></i>',
            'info': '<i class="fa fa-times-circle" ></i>'
        };
    };
    CommonService.prototype.getNotificationTemplate = function (title, content) {
        if (title === void 0) { title = ''; }
        if (content === void 0) { content = ''; }
        var html = "<div>\n                    <div class=\"sn-title\">" + title + "</div>\n                    <div>" + content + "</div>\n                  </div>";
        return html;
    };
    CommonService.prototype.getNotificationType = function (type) {
        switch (type) {
            case 'success':
                return NotificationType.SUCCESS;
            case 'error':
                return NotificationType.ERROR;
            case 'warning':
                return NotificationType.WARN;
            case 'alert':
                return NotificationType.ALERT;
            case 'info':
                return NotificationType.INFO;
            default:
                return NotificationType.SUCCESS;
        }
    };
    CommonService.prototype.checkPermission = function (permission) {
        if (this._cacheService.get(CacheKey.UserPermissions) != null && this._cacheService.get(CacheKey.UserPermissions) != undefined) {
            var permissionsArray = JSON.parse(this._cacheService.get(CacheKey.UserPermissions));
            if (permissionsArray.indexOf(permission) >= 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    CommonService.prototype.getUserInformation = function (userName) {
        var url = environment.accountThroughGateway + 'users/' + userName + '/user-types/Titan-Internal/info';
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map(function (res) { return res.json(); })
            .catch(function (error) {
            return Observable.throw(error.json().error || 'server error');
        });
    };
    /**
     * CustomerService - Gets search results
     * @param searchRequest
     * @param pageNumber
     * @param pageSize
     * @param sort
     * @param sortColumn
     */
    CommonService.prototype.getFBOSearchResults = function (searchRequest) {
        var url = '';
        if (searchRequest.searchBy === Constants.MEMBER) {
            url = ApiUrlConstants.manageAccountApiGwUrl + 'member-search';
        }
        return this._http
            .post(url, JSON.stringify(searchRequest))
            .map(function (response) { return response.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
     * CustomerService - Gets account status
     * @param distributorID
     */
    CommonService.prototype.getMemberStatus = function (distributorID) {
        return this._http
            .get(ApiUrlConstants.customerServiceApiUrl + 'account-status?distributorID=' + distributorID)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
       * to get wholesale qualified details for a PC based on memberID and countryCode
       * @param  {any} memberId
       * @param  {any} countryCode
       * @returns Observable
       */
    CommonService.prototype.getWholsesaleQualifiedDetails = function (memberId, countryCode) {
        return this._http
            .get(ApiUrlConstants.enrollmentApigwUrl + 'wholesaleQualifiedEligibilityCheck?distributorId='
            + memberId + '&operatingCountry=' + countryCode)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
     * @description
     * @date 2020-04-20
     * @param {string} memberId
     * @param {number} countryId
     * @returns {Observable<any>}
     * @memberof CommonService
     */
    CommonService.prototype.getMemberRankLevelHistory = function (memberId, countryId) {
        return this._http
            .get(ApiUrlConstants.accountApiUrl + 'member/' + memberId + '/country/' + countryId + '/member-rank-level-history')
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
     * to get wholesale qualified details for a PC based on memberID and countryCode
     * @param  {any} memberId
     * @param  {any} countryCode
     * @returns Observable
     */
    CommonService.prototype.getDiscountPercentages = function (wholesaleQualified, optin, memberTitleID, storeId) {
        var url = ApiUrlConstants.configurationApiUrl
            + 'discount-percentages?wholeSaleQualified=' + wholesaleQualified + '&optin=' + optin
            + '&memberTitleId=' + memberTitleID + '&storeId=' + storeId;
        return this._http
            .get(url)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
     * getCountries Method used to get country list
     * @param  {number} distributorId
     * @param  {string} homeCountry ,homeCountry: string + homeCountry
     * @returns Observable
     */
    CommonService.prototype.getCountries = function (distributorId, homeCountry) {
        var url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/countries?homeCountry=' + homeCountry;
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.getSearchMemberDetails = function (distributors, countryCode) {
        var url = ApiUrlConstants.reportApiUrl + '/search-detail?';
        distributors.forEach(function (ele) { return url = url + 'distributors=' + ele + '&'; });
        url = url + '&countryCode=' + countryCode;
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.getSearchList = function (distributorId, firstName, lastName, countryCode, rootId) {
        var url = ApiUrlConstants.reportApiUrl + '/search?countryCode=' + countryCode + '&rootId=' + rootId;
        if (distributorId != '') {
            url = url + '&distributorId=' + distributorId;
        }
        else if (firstName != '' && lastName != '') {
            url = url + '&firstName=' + firstName + '&lastName=' + lastName;
        }
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
        * getVerticalView Method used to get downline members of logged in fbo
        * @param  {number} distributorId
        * @param  {string} country
        * @returns Observable
        */
    CommonService.prototype.getVerticalTree = function (distributorId, countryCode, memberLevel, fromDate, toDate, showNonZero) {
        var initialurl;
        var appendurl = '';
        var url = '';
        initialurl = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/verticaltreeview?countryCode=' + countryCode
            + '&memberLevel=' + memberLevel + '&fromDate=' + fromDate + '&toDate=' + toDate + '&showNonZero=' + showNonZero;
        url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/verticaltreeview?';
        initialurl.split('?')[1].split('&').forEach(function (ele) {
            var value = ele.split('=')[1];
            if (value !== 'null' && value !== 'undefined' && value !== '') {
                appendurl += '&' + ele;
            }
        });
        url += appendurl.replace('&', '');
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
      * getVerticalView Method used to get downline members of logged in fbo
      * @param  {number} distributorId
      * @param  {string} country
      * @returns Observable
      */
    CommonService.prototype.getVerticalTreeCCValues = function (distributorId, countryCode) {
        var url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/treeview-cc?countryCode=' + countryCode;
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
        * getCCSnapshotDetails Method used to get ccs of logged in fbo
        * @param  {number} distributorId
        * @param  {string} country
        * @returns Observable
        */
    CommonService.prototype.getTwoCCSnapshotDetails = function (distributorId, countryCode) {
        var initialurl;
        var appendurl = '';
        var url = '';
        initialurl = 'countryCode=' + countryCode;
        url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/cc-two-snapshot?';
        initialurl.split('&').forEach(function (ele) { var value = ele.split('=')[1]; if (value != 'null' && value != 'undefined' && value != '') {
            appendurl += '&' + ele;
        } });
        url += appendurl.replace('&', '');
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.getCCSnapshotDetails = function (distributorId, countryCode) {
        var initialurl;
        var appendurl = '';
        var url = '';
        initialurl = 'countryCode=' + countryCode;
        url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/cc-snapshot?';
        initialurl.split('&').forEach(function (ele) { var value = ele.split('=')[1]; if (value != 'null' && value != 'undefined' && value != '') {
            appendurl += '&' + ele;
        } });
        url += appendurl.replace('&', '');
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.getCCSnapDetails = function (reqObj) {
        var url;
        if (environment && environment.enableNewAggregation) {
            url = ApiUrlConstants.reportApiUrl + '/fboId/' + reqObj.distributorID + '/country/' + reqObj.country + '/year/' + reqObj.currentYear + '/month/' + reqObj.month + '/rewire-earnings-CC-summary?isVolume=false';
        }
        else {
            url = ApiUrlConstants.reportApiUrl + '/fboId/' + reqObj.distributorID + '/country/' + reqObj.country + '/year/' + reqObj.currentYear + '/month/' + reqObj.month + '/earnings-CC-summary?isVolume=false';
        }
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    /**
      * getYearlyCaseCreditsDetails Method used to get ccs of logged in fbo
      * @param  {number} distributorId
      * @param  {string} country
      * @returns Observable
      */
    CommonService.prototype.getYearlyCaseCreditsDetails = function (distributorId, countryCode, processingYear) {
        var initialurl;
        var appendurl = '';
        var url = '';
        initialurl = 'countryCode=' + countryCode + '&processingYear=' + processingYear;
        url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/casecredits?';
        initialurl.split('&').forEach(function (ele) { var value = ele.split('=')[1]; if (value != 'null' && value != 'undefined' && value != '') {
            appendurl += '&' + ele;
        } });
        url += appendurl.replace('&', '');
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
     * getAveragePurchase Method used to get Average Purchase Data
     * @param  {number} distributorId
     * @param  {string} country
     * @returns Observable
     */
    CommonService.prototype.getBonusRecapData = function (distributorId, country, month, year) {
        var url = ApiUrlConstants.reportApiUrl + '/member/bonusrecap/distributors/' + distributorId + '/countries/' + country + '?month=' + month + '&year=' + year;
        var headers = new Headers();
        headers.append('Accept', 'application/pdf');
        var options = new RequestOptions({
            responseType: ResponseContentType.Blob,
            headers: headers
        });
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)), options)
            .map(function (res) { return res; })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.getMemberLevelDetails = function (distributorId) {
        var url = ApiUrlConstants.reportApiUrl + '/distributors/' +
            distributorId + '/member-information';
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.getRecognitionLevelsByParam = function (param) {
        return this._http
            .get(ApiUrlConstants.reportApiUrl + '/recognitionlevels/' + param)
            .map(function (response) { return response.json(); })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.getRoutePermissions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._http.get(this.routePermissionURL).toPromise()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    CommonService.prototype.arraySort = function (value, property, isDesc) {
        var isDescOrder = isDesc ? isDesc : false; //change the direction
        var direction = (isDesc ? isDesc : false) ? 1 : -1;
        value.sort(function (a, b) {
            if (a[property] < b[property]) {
                return -1 * direction;
            }
            else if (a[property] > b[property]) {
                return 1 * direction;
            }
            else {
                return 0;
            }
        });
        return value;
    };
    /**
     * @description get purchase flow type
     * @returns {*}
     * @memberof CommonService
     */
    CommonService.prototype.getPurchaseFlowType = function (memberTypeId, wholesaleQualified, fpc5percentEnabled, isFPCEnrollment, memberTitleId) {
        if ((memberTypeId === MemberTypeEnum.DISTRIBUTOR && memberTitleId !== MemberLevel.PREFERREDCUSTOMER)
            || ((memberTypeId === MemberTypeEnum.FPC || memberTitleId === MemberLevel.PREFERREDCUSTOMER) && wholesaleQualified)) {
            return PurchaseFlows.PERSONAL;
        }
        else if ((memberTypeId === MemberTypeEnum.FPC || memberTitleId === MemberLevel.PREFERREDCUSTOMER) && !wholesaleQualified) {
            return fpc5percentEnabled ? PurchaseFlows.FPC5PERCENT : PurchaseFlows.PERSONAL;
        }
        else if (isFPCEnrollment) {
            return PurchaseFlows.ENROLLMENT;
        }
        else {
            return PurchaseFlows.RETAIL;
        }
    };
    /**
     * save saveMemberActivity
     * @param  {any} Member Activity Log
     * @returns Observable
     */
    CommonService.prototype.saveMemberActivity = function (memberId, activityLogKeys) {
        var activityLog = {
            activities: activityLogKeys,
            portalId: MemberActivityLogPortal.CustomerService
        };
        return this._http
            .post(ApiUrlConstants.auditApiUrl + 'members/' + memberId + '/activitylog', activityLog)
            .map(function (res) { return res.text(); })
            .catch(this.handleErrorObservable);
    };
    /**
   * @description to get error codes based on country,state and product item number
   * @param {*} productRestrictionModel
   * @returns
   * @memberof CommonService
   */
    CommonService.prototype.getProductRestrictions = function (productRestrictionModel) {
        return this._http
            .post(ApiUrlConstants.shippingApiUrl + 'shipping-products-restriction', JSON.stringify(productRestrictionModel))
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
       * To handle the obervable error response
       * @param  {Response|any} error
       */
    CommonService.prototype.handleErrorObservable = function (error) {
        return Observable.throw(error);
    };
    /**
  * @description get phone number format based on country code
  * @date 2018-11-22
  * @param {string} countryCode
  * @returns {string}
  * @memberof CommonService
  */
    CommonService.prototype.getPhoneNumberFormatByCountryCode = function (countryCode) {
        if (countryCode) {
            var phoneNumberFormat = CountryPhoneNumberFormats.formats.find(function (item) { return item.countryCode.toUpperCase() === countryCode.toUpperCase(); });
            if (phoneNumberFormat) {
                return phoneNumberFormat.phoneNumberMaskFormat;
            }
            else {
                return CommonConstant.DefaultPhoneNumberFormat;
            }
        }
        else {
            return CommonConstant.DefaultPhoneNumberFormat;
        }
    };
    /**
   * @description this method will return the price level based on member
   * @returns {string}
   * @memberof CommonService
   */
    CommonService.prototype.getDiscountPriceLevel = function (priceTierId, discountPerc, memberTypeId, enableWHLSAL00ForAsstSupervisor, isServiceOrder) {
        var priceLevel;
        if (isServiceOrder) {
            return Constants.SERVICE_ORDER;
        }
        switch (priceTierId) {
            case PriceTier.RETAIL:
                priceLevel = PriceTierMemberType.RETAIL;
                break;
            case PriceTier.NEWDST:
                priceLevel = PriceTierMemberType.FPC + ' ' + discountPerc + '%';
                break;
            case PriceTier.WHLSAL:
                priceLevel = PriceTierMemberType.FPC + ' ' + discountPerc + '%';
                break;
            case PriceTier.WHLD05:
                priceLevel = PriceTierMemberType.FBO + ' ' + discountPerc + '%';
                break;
            case PriceTier.WHLD08:
            case PriceTier.WHLD13:
            case PriceTier.WHLD18:
                priceLevel = PriceTierMemberType.FBO + ' ' + discountPerc + '%';
                break;
            case PriceTier.RTLD5:
            case PriceTier.RTLD10:
            case PriceTier.RTLD15:
                priceLevel = PriceTierMemberType.RETAIL + ' ' + DiscountTypeConstants.discountTypes[priceTierId] + '%';
                break;
            case PriceTier.WHLD00:
                priceLevel = PriceTierMemberType.FBO;
                break;
            case PriceTier.NEWFBO:
                priceLevel = PriceTierMemberType.NEWFBO;
                break;
            default:
                priceLevel = '';
                break;
        }
        return priceLevel;
    };
    /**
     * @description discount percentage based on UserTitleType
     * @param {number} memberTitleId
     * @param {boolean} wholesaleQualified
     * @returns {number}
     * @memberof CommonService
     */
    CommonService.prototype.getDiscountPerc = function (memberDiscountPercentage) {
        var discountPercenatge = 0;
        if (memberDiscountPercentage && memberDiscountPercentage.discountPercentage) {
            discountPercenatge = memberDiscountPercentage.discountPercentage;
        }
        return discountPercenatge;
    };
    /**
     * @description
     * @date 2019-09-17
     * @returns {number}
     * @memberof CommonService
     */
    CommonService.prototype.getWholesaleQualifiedDisc = function (memberTitleId) {
        var discountPercenatge = 0;
        switch (memberTitleId) {
            case MemberLevel.PREFERREDCUSTOMER:
                discountPercenatge = 0;
                break;
            case MemberLevel.ASSISTANTSUPERVISOR:
            case MemberLevel.SUPERVISOR:
            case MemberLevel.ASSISTANTMANAGER:
            case MemberLevel.MANAGER:
            case MemberLevel.DIAMONDMANAGER:
            case MemberLevel.UNRECOGNIZEDMANAGER:
            case MemberLevel.RECOGNIZEDMANAGER:
            case MemberLevel.SENIORMANAGER:
            case MemberLevel.SOARINGMANAGER:
            case MemberLevel.SAPPHIREMANAGER:
            case MemberLevel.DIAMONDSAPPHIREMANAGER:
            case MemberLevel.DOUBLEDIAMONDMANAGER:
            case MemberLevel.TRIPLEDIAMONDMANAGER:
            case MemberLevel.DIAMONDCENTURIONMANAGER:
                discountPercenatge = 30;
                break;
            default:
                break;
        }
        return discountPercenatge;
    };
    /**
   * @description Getting personal info form validations json
   *
   * @param {string} schemaUrl
   * @returns {Observable<any>}
   * @memberof CommonService
   */
    CommonService.prototype.getFormValidationsJSON = function () {
        return this._http
            .get(this._personaliInfoFormValidation + 'validations.json')
            .map(function (res) { return res.json(); })
            .catch(function (error) {
            return Observable.throw(error.message || error);
        });
    };
    /**
     * This method is used for getting company policy agreement documents
     * getDocuments
     * @memberof CommonService
     */
    CommonService.prototype.getDocuments = function (portalId, customerTypeId, displaySectionId, countryCode, languageCode) {
        return (this._http
            .get(ApiUrlConstants.accountApiUrl + 'documents?countryCode=' + countryCode + '&portal=' + portalId
            + '&customerTypeId=' + customerTypeId + '&preferredLangCode=' + languageCode + '&displaySectionId=' + displaySectionId)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable));
    };
    /**
     * Sponsor Search
     * @param  {any} sponsorSearchRequest
     * @param  {number} limit?
     * @returns Observable
     */
    CommonService.prototype.searchSponsors = function (sponsorSearchRequest, limit) {
        var orderType = OrderType.NEW_GUEST_RETAIL;
        var flowtype = OrderType[orderType];
        var _searchSponsorUrl = ApiUrlConstants.enrollmentApigwUrl +
            ("sponsor-search?flowtype=" + flowtype + "&app=csp");
        return this._http
            .post(_searchSponsorUrl, sponsorSearchRequest)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
     * @description this method will  get sponsor by uuid
     * @date 2019-03-18
     * @returns {Observable<SponsorSearchResponse>}
     * @memberof CommonService
     */
    CommonService.prototype.getSearchSponsorsByUUID = function (sponsorSearchResponse) {
        var _searchSponsorUrl = sponsorSearchResponse.location;
        return this._http
            .get(decodeURIComponent(encodeURIComponent(_searchSponsorUrl)))
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
     * @description this method will map addess
     * of sponsor
     * @date 2018-10-16
     * @param {*} sponsor
     * @returns {Address}
     * @memberof SponsorSelectionComponentNew
     */
    CommonService.prototype.mapAddressModel = function (sponsor) {
        // creating a address object to be added to sponsor info
        var address = {
            id: null,
            memberId: null,
            addressLine1: sponsor.sponsorAddressLine1,
            addressLine2: null,
            addressLine3: null,
            addressLine4: null,
            city: sponsor.sponsorCity,
            stateId: sponsor.sponsorStateId,
            countryId: sponsor.sponsorCountryId,
            postalCode: sponsor.sponsorPostalCode,
            addressVerificationStatus: false,
            addressType: null,
            state: sponsor.sponsorStateCode,
            stateCode: sponsor.sponsorStateCode,
            countryCode: sponsor.sponsorCountryCode,
            country: sponsor.sponsorCountryCode,
            latitude: null,
            longitude: null,
            defaultAddress: null,
            county: null,
            name: null,
            company: null,
            errorCodes: null,
            formattedAddress: null,
            organization: null,
            countryFullName: null,
            phone: null,
            countryCodeTwo: null,
            residential: false,
            validAddress: false
        };
        return address;
    };
    /** To trim the String values in a object
    * @description
    * @author njagadeesan
    * @date 2019-12-17
    * @param {*} obj
    * @returns {*}
    * @memberof CommonService   */
    CommonService.prototype.trimObjectValues = function (obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                var value = obj[key];
                if (typeof (value) === 'string') {
                    value = value && value.trim();
                }
                obj[key] = value;
            }
        }
        return obj;
    };
    /** To update traget in url
   * @description
   * @author bsubramanian
   * @date 2020-02-10
   * @param {*} obj
   * @returns {*}
   * @memberof CommonService   */
    CommonService.prototype.replaceLinks = function (ticketingModel) {
        var description = ticketingModel && ticketingModel.description;
        if (description && description.indexOf('<a href') > -1 && description.indexOf('target=_blank') === -1) {
            ticketingModel.description = description.replace(/href=/g, ' target=_blank href=');
        }
    };
    /**
     * To get list of countries
     * @returns Observable
     */
    CommonService.prototype.getAllCountries = function () {
        var url = ApiUrlConstants.configurationApiUrl + 'countries';
        return this._http.get(url)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
     * @description to convert code to Id vice-versa
     * @author Akhil
     * @date 2020-03-26
     * @param {*} value
     * @param {boolean} [countryCode]
     * @returns
     * @memberof CommonService
     */
    CommonService.prototype.getCountry = function (value, isCountryCode) {
        var countries = this._cacheService.get(CacheKey.COUNTRIES);
        if (countries && value) {
            if (isCountryCode) {
                var country = countries.find(function (country) { return country.isocodeThree.toLowerCase() === value.toLowerCase(); });
                return country && country.id ? country.id : country.countryId;
            }
            else {
                var country = countries.find(function (country) { return country.id ? country.id === value : country.countryId === value; });
                return country && country.isocodeThree;
            }
        }
    };
    CommonService.prototype.jumpingScroll = function (onShow) {
        var body = document.body;
        if (body) {
            var offset = (window.innerWidth - body.clientWidth);
            if (onShow) {
                if (offset > 0) {
                    $('.global-banner').css({ 'padding-right': offset + 'px' });
                    $('.nav-tabs.cs-primary-tabs > ul.nav-tabs, .nav-tabs.cs-secondary-tabs > ul.nav-tabs').css({ 'left': 'calc(50% - 8.5px)' });
                }
            }
            else {
                $('.global-banner').css({ 'padding-right': '0px' });
                $('.nav-tabs.cs-primary-tabs > ul.nav-tabs, .nav-tabs.cs-secondary-tabs > ul.nav-tabs').css({ 'left': '50%' });
            }
        }
    };
    /**
   * @description to get all the Zip Code Patterns
   * @returns {Observable<any>}
   * @memberof CommonService
   */
    CommonService.prototype.getZipCodePatterns = function () {
        return this._http
            .get(environment.uiTemplateBaseUrl + '/test/zipcode-configuration.json')
            .map(function (res) { return res.json(); })
            .pipe(catchError(this.handleErrorObservable));
    };
    CommonService.prototype.clearKeyCloakCache = function (userName) {
        var keyclockCacheUrl = environment.ssoInternalUserCacheUrl
            + userName + '/clear-cache';
        return this._http.get(keyclockCacheUrl).map(function (response) {
            return response.json();
        }).catch(this.handleErrorObservable);
    };
    CommonService.prototype.isWHLSAL00enabledForAsstSupervisor = function (countryCode) {
        var enabledCountries = environment.enableWHLSAL00ForAsstSupervisor ?
            environment.enableWHLSAL00ForAsstSupervisor.split(',') : null;
        var country = enabledCountries && enabledCountries.length ? enabledCountries.find(function (ISOcodeThree) {
            return ISOcodeThree.toLowerCase() === countryCode.toLowerCase();
        }) : null;
        var enableWHLSAL00ForAsstSupervisor = country && country.length ? true : false;
        return enableWHLSAL00ForAsstSupervisor;
    };
    CommonService.prototype.getCurrencyFormat = function (store, format, value) {
        var chunkLength = 3;
        value = +value || 0;
        var num = store.numberDecimals ? value.toFixed(Math.max(0, ~~store.numberDecimals)) : value.toFixed(2);
        var result = '\\d(?=(\\d{' + chunkLength + '})+' + (store.numberDecimals > 0 ? '\\D' : '$') + ')';
        var formattedCurrency = '';
        //let currencyCode: string = store.currencyCode;
        var currencySymbol = store.currencySymbol;
        switch (format) {
            case 'CL':
                formattedCurrency = (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator ? store.thousandSeperator : ''));
                break;
            case 'CR':
                formattedCurrency = (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator ? store.thousandSeperator : ''));
                break;
            case 'SL':
                formattedCurrency = currencySymbol + (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator ? store.thousandSeperator : ''));
                break;
            case 'SR':
                formattedCurrency = (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator ? store.thousandSeperator : '')) + currencySymbol;
                break;
            case 'CRSL':
                formattedCurrency = currencySymbol + (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator ? store.thousandSeperator : ''));
                break;
            case 'SRCL':
                formattedCurrency = (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator ? store.thousandSeperator : '')) + currencySymbol;
                break;
            default:
                formattedCurrency = currencySymbol + (store.decimalSeparator ?
                    num.replace('.', store.decimalSeparator) : num).replace(new RegExp(result, 'g'), '$&' +
                    (store.thousandSeperator ? store.thousandSeperator : ''));
                break;
        }
        return formattedCurrency;
    };
    CommonService.prototype.getMemberShippingDiscountOffer = function (memberId, countryCode) {
        var url = ApiUrlConstants.accountApiUrl + 'member-discount-offer/member/' + memberId + '/country/' + countryCode + "?DiscountTypeID=" + DiscountType.ShippingDiscount;
        return this._http.get(url)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
      * get member account level id
      */
    CommonService.prototype.getMemberAccountLevelId = function (userInfo) {
        var accountLevelId = null;
        if (userInfo && userInfo.memberRankLevels && userInfo.memberRankLevels.length > 0) {
            accountLevelId = userInfo.memberRankLevels[0].accountLevelId ? userInfo.memberRankLevels[0].accountLevelId : null;
        }
        return accountLevelId;
    };
    /**
     * removeMemberDiscountOffer()
     * @param  {number} memberId
     * @returns Observable
     */
    CommonService.prototype.removeMemberDiscountOffer = function (memberId) {
        var url = ApiUrlConstants.manageAccountApiGwUrl + 'member-discount-offer/' + memberId + "?DiscountTypeID=" + DiscountType.ShippingDiscount;
        return this._http
            .delete(url)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
     * PRICE and CC validation check when order value type is BOTH
     */
    CommonService.prototype.validateSubTotalBasedOnBothPriceAndCC = function (orderRules, isLiteratureProduct, subTotal, totalCC) {
        var valid;
        valid = { thresholdCrossed: false, monthlyCCValue: 0, monthlyCCValid: false, cartLimitExceed: false, cartLimitNotReach: false };
        if (orderRules && isLiteratureProduct) {
            if (subTotal > orderRules.literatureMaxValue) {
                valid.cartLimitExceed = true;
                valid.thresholdCrossed = true;
            }
            else if (subTotal < orderRules.literatureMinValue) {
                valid.cartLimitNotReach = true;
                valid.thresholdCrossed = true;
            }
            else {
                valid.thresholdCrossed = false;
            }
        }
        else if (orderRules && totalCC) {
            if (totalCC >= orderRules.maxCCValue) {
                valid.monthlyCCValid = true;
                valid.thresholdCrossed = true;
            }
            else {
                valid.monthlyCCValid = false;
                valid.thresholdCrossed = false;
            }
        }
        valid.monthlyCCValue = orderRules.maxCCValue;
        return valid;
    };
    /**
     * @description Get member details are privacy enabled
     * @author njagadeesan
     * @date 2020-09-03
     * @param {*} memberPreferences
     * @returns {string}
     * @memberof CommonService
     */
    CommonService.prototype.isPrivacyRequested = function (memberPreferences) {
        var byPhoneOrMail;
        if (memberPreferences && memberPreferences.length) {
            byPhoneOrMail = memberPreferences.find(function (item) {
                return (item.preferenceId === MemberPreferenceType.Email)
                    && +item.preferenceValue === PreferenceValues.no;
            });
        }
        return byPhoneOrMail ? 'Yes' : 'No';
    };
    CommonService.prototype.validateNumberDecimalPoint = function (n) {
        return (n - Math.floor(n)) !== 0;
    };
    CommonService.prototype.getMemberInfoByMemberId = function (memberId) {
        if (memberId) {
            var url = ApiUrlConstants.accountApiUrl + 'members/lookup?memberIds=' + memberId;
            return this._http
                .get(decodeURIComponent(encodeURIComponent(url)))
                .map(function (res) { return res.json(); })
                .catch(this.handleErrorObservable);
        }
        else {
            return Observable.throw('Member Id is not available');
        }
    };
    /**
         * getVatDetail()
         * @param selectedCountryID
         */
    CommonService.prototype.getVatDetail = function (country, memberInfo) {
        if (country && memberInfo && memberInfo.vatDetailModel && memberInfo.vatDetailModel.length
            && memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR) {
            var vatDetail = memberInfo.vatDetailModel.find(function (item) { return item.vatRegisteredCountry === Number(country.countryId); });
            var appConfigSetting = this.appConfigService.getSettings(country.isocodeThree, memberInfo);
            if (appConfigSetting && appConfigSetting.enableVatExempt) {
                memberInfo.vatRegistered = (vatDetail && vatDetail.vatID && vatDetail.vatExempt) ? true : false;
            }
            else {
                memberInfo.vatRegistered = vatDetail ? true : false;
            }
            return memberInfo.vatRegistered;
        }
    };
    /**
     * processPollRequest
     * @param  {Order} processPollRequest
     * @returns Observable
     */
    CommonService.prototype.processPollRequest = function (requestUrl) {
        return (this._http
            .get(requestUrl)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable));
    };
    /**
     * @description To remove payvision widget configurations
     * @author njagadeesan
     * @date 2020-11-19
     * @memberof CommonService
     */
    CommonService.prototype.unloadPayvisionWidget = function () {
        var widgetWindow = window;
        if (widgetWindow.wpwl && widgetWindow.wpwl.unload) {
            widgetWindow.wpwl.unload();
            $('script').each(function () {
                var scriptEle = this;
                if (scriptEle.src && scriptEle.src.indexOf('static.min.js') !== -1) {
                    $(this).remove();
                }
            });
        }
    };
    /**
    *
    * @param storeId
    */
    CommonService.prototype.getStoreMetaData = function (storeId) {
        return this._http
            .get(ApiUrlConstants.configurationApiUrl + 'stores/' + storeId + '/store-metadata')
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    /**
     * @description To get Government Identifiction based on country code
     * @date 2021-03-31
     * @returns {Observable<any[]>}
     * @memberof CommonService
     */
    CommonService.prototype.getGovermentIdentificationPatterns = function () {
        //get(environment.uiTemplateBaseUrl + '/test/goverment-identification-patterns.json')
        return this._http
            .get(environment.cdnURL + '/portals/customercare/template1/schema-forms/goverment-identification-patterns.json')
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.anonymousSponsorSearch = function (distributorId) {
        var anonymousSponsorSearchRequest = ApiUrlConstants.accountApiUrl + 'fbo/' + distributorId + '/basic-details';
        return this._http
            .get(anonymousSponsorSearchRequest).map(function (res) { return res.json(); })
            .pipe(catchError(this.handleErrorObservable));
    };
    CommonService.prototype.getPosMembrOrderElible = function () {
        return this._http
            .get(environment.cdnURL + '/portals/customercare/template1/schema-forms/pos-member-type-config.json')
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.isenableCloneOrderCountries = function (countryCode) {
        var enabledCountries = environment.enableCloneOrderCountries ?
            environment.enableCloneOrderCountries.split(',') : null;
        var country = enabledCountries && enabledCountries.length ? enabledCountries.find(function (ISOcodeThree) {
            return ISOcodeThree.toLowerCase() === countryCode.toLowerCase();
        }) : null;
        var enableCloneOrderCountries = country && country.length ? true : false;
        return enableCloneOrderCountries;
    };
    /**
       * @description Method to sort member address based on name
       * @date 2021-04-21
       * @memberof OrderEditComponent
       */
    CommonService.prototype.sortMemberAddress = function (memberAddressDetails) {
        if (memberAddressDetails && memberAddressDetails.length > 1) {
            var direction_1 = 1;
            memberAddressDetails.sort(function (a, b) {
                var nameObj1 = ((a.firstName ? a.firstName : "") +
                    (a.middleName ? a.middleName : "") +
                    (a.lastName ? a.lastName : "")).toLowerCase();
                var nameObj2 = ((b.firstName ? b.firstName : "") +
                    (b.middleName ? b.middleName : "") +
                    (b.lastName ? b.lastName : "")).toLowerCase();
                if (nameObj1 < nameObj2) {
                    return -1 * direction_1;
                }
                else if (nameObj1 > nameObj2) {
                    return 1 * direction_1;
                }
                else {
                    return 0;
                }
            });
        }
        return memberAddressDetails;
    };
    /**
       * @description Method to search address based on name
       * @date 2021-04-21
       * @memberof OrderEditComponent
       */
    CommonService.prototype.searchShippingAddress = function (event, memberAddressDetails) {
        var addressSearchResult;
        var searchFilter = event.target.value;
        if (searchFilter.length > 0) {
            searchFilter = searchFilter.toLowerCase();
            addressSearchResult = memberAddressDetails.filter(function (address) {
                var name = ((address.firstName ? address.firstName + " " : "") +
                    (address.middleName ? address.middleName + " " : "") +
                    (address.lastName ? address.lastName : "")).toLowerCase();
                return name.indexOf(searchFilter) > -1;
            });
        }
        else {
            addressSearchResult = memberAddressDetails;
        }
        return addressSearchResult;
    };
    CommonService.prototype.focusInvalidElement = function () {
        var invalidFields = document.querySelectorAll('.alert-msg');
        if (invalidFields[0]) {
            var offSetHeight = invalidFields[0].offsetTop;
            if (offSetHeight) {
                window.scroll(0, offSetHeight);
            }
        }
    };
    /**
     * Check order Promotion is available
     * @param promotions
     * @param freeProductsInfo
     * @param items
     */
    CommonService.prototype.validateOrderCriteria = function (promotions, freeProductsInfo, items) {
        var orderPromotions = promotions.filter(function (promotion) { return promotion.promotionActionTypeId === PromotionActionType.ORDER; });
        if (items && items.length > 0) {
            var orderItems = items.controls.filter(function (item) {
                return item.controls['productItem'].value.orderPromotionTrackings == null;
            });
            if (orderPromotions && orderPromotions.length && orderItems && orderItems.length > 0) {
                this.updateSingleProductQuantityPromotion(orderPromotions, freeProductsInfo, items);
            }
        }
    };
    /**
     * Check order sub total is satisfied
     * @param promotions
     * @param freeProductsInfo
     * @param items
     */
    CommonService.prototype.validateOrderSubTotalCriteria = function (promotions, freeProductsInfo, items) {
        var orderSubTotalPromotions = promotions.filter(function (promotion) { return promotion.promotionActionTypeId === PromotionActionType.ORDERSUBTOTAL; });
        if (orderSubTotalPromotions && orderSubTotalPromotions.length) {
            this.updateSingleProductQuantityPromotion(orderSubTotalPromotions, freeProductsInfo, items, PromotionActionType.ORDERSUBTOTAL);
        }
    };
    /**
     * Check order cc is satisfied
     * @param promotions
     * @param freeProductsInfo
     * @param items
     */
    CommonService.prototype.validateOrderCCCriteria = function (promotions, freeProductsInfo, items) {
        var orderOrderCCPromotions = promotions.filter(function (promotion) { return promotion.promotionActionTypeId === PromotionActionType.ORDERCC; });
        if (orderOrderCCPromotions && orderOrderCCPromotions.length) {
            this.updateSingleProductQuantityPromotion(orderOrderCCPromotions, freeProductsInfo, items, PromotionActionType.ORDERCC);
        }
    };
    /**
     * Check Qualify product promotion is satisfied
     * @param promotions
     * @param freeProductsInfo
     * @param item
     */
    CommonService.prototype.validateProductCriteria = function (promotions, freeProductsInfo, items) {
        var productPromotions = promotions.filter(function (promotion) { return promotion.promotionActionTypeId === PromotionActionType.PRODUCT; });
        if (productPromotions && productPromotions.length) {
            productPromotions.forEach(function (promotion) {
                var productIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value ===
                    promotion.qualifyingProductId; });
                if (productIndex > -1 && !(promotion.promotionSingleUse && promotion.redemptionUsageCount > 0)) {
                    var productQty = items.controls[productIndex].controls['quantity'].value;
                    freeProductsInfo.push({
                        productId: promotion.freeProductId,
                        quantity: promotion.promotionSingleUse ? promotion.freeProductQuantityCount : productQty * promotion.freeProductQuantityCount,
                        promotionId: [promotion.promotionId]
                    });
                }
            });
        }
    };
    /**
     * Check product at quantity promotion is satisfied
     * @param promotions
     * @param freeProductsInfo
     * @param item
     */
    CommonService.prototype.validateProductAtQuantityCriteria = function (promotions, freeProductsInfo, items) {
        var productAtQuantityPromotions = promotions.filter(function (promotion) { return promotion.promotionActionTypeId === PromotionActionType.PRODUCT_QUANTITY; });
        if (productAtQuantityPromotions && productAtQuantityPromotions.length) {
            productAtQuantityPromotions.forEach(function (promotion) {
                var productIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value ===
                    promotion.qualifyingProductId; });
                if (productIndex > -1 && !(promotion.promotionSingleUse && promotion.redemptionUsageCount > 0)) {
                    var productQty = items.controls[productIndex].controls['quantity'].value;
                    ;
                    if (productQty >= promotion.qualifyingQuantityCount) {
                        freeProductsInfo.push({
                            productId: promotion.freeProductId,
                            quantity: promotion.promotionSingleUse ? promotion.freeProductQuantityCount :
                                Math.floor(productQty / promotion.qualifyingQuantityCount) * promotion.freeProductQuantityCount,
                            promotionId: [promotion.promotionId]
                        });
                    }
                }
            });
        }
    };
    /**
     * Check Mulptiple product promotion is satisfied
     * @param promotions
     * @param freeProductsInfo
     * @param items
     */
    CommonService.prototype.validateMultipleProductCriteria = function (promotions, freeProductsInfo, items) {
        var multipleProductPromotions = promotions.filter(function (promotion) { return promotion.promotionActionTypeId === PromotionActionType.MULTIPLE_PRODUCTS; });
        if (multipleProductPromotions && multipleProductPromotions.length && items) {
            multipleProductPromotions.forEach(function (promotion) {
                var firstProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value ===
                    promotion.qualifyingProductId; });
                var secondProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value ===
                    promotion.secondQualifyingProductId; });
                if (firstProductIndex > -1 && secondProductIndex > -1) {
                    var firstProductQuantity = items.controls[firstProductIndex].controls['quantity'].value;
                    var secondProductQuantity = items.controls[secondProductIndex].controls['quantity'].value;
                    if (!(promotion.promotionSingleUse && promotion.redemptionUsageCount > 0)) {
                        freeProductsInfo.push({
                            productId: promotion.freeProductId,
                            quantity: promotion.promotionSingleUse ? promotion.freeProductQuantityCount :
                                Math.min(firstProductQuantity, secondProductQuantity) * promotion.freeProductQuantityCount,
                            promotionId: [promotion.promotionId]
                        });
                    }
                }
            });
        }
    };
    /**
    * To update Free Prodcut Id to Free product info
    * @param promotions
    * @param freeProductsInfo
    */
    CommonService.prototype.updateSingleProductQuantityPromotion = function (orderPromotions, freeProductsInfo, items, filter) {
        var _this = this;
        orderPromotions.forEach(function (promotion) {
            if (items && items.length > 0) {
                if ((filter === PromotionActionType.ORDERSUBTOTAL && (_this.itemSubTotal < promotion.subTotalValueCap)) ||
                    (filter === PromotionActionType.ORDERCC && (_this.totalCC < promotion.ccValueCap)) ||
                    (promotion.promotionSingleUse && promotion.redemptionUsageCount > 0)) {
                    return;
                }
                if (filter === PromotionActionType.ORDERSUBTOTAL && (_this.countryTaxInclusive !== promotion.taxOptionValue))
                    return;
                freeProductsInfo.push({
                    productId: promotion.freeProductId,
                    quantity: promotion.freeProductQuantityCount,
                    promotionId: [promotion.promotionId]
                });
            }
        });
    };
    /**
     * To Remove duplicate product Ids from Free Product Info
     * @param freeProductsInfo
     * @returns
     */
    CommonService.prototype.removeDuplicates = function (freeProductsInfo) {
        var products = freeProductsInfo.reduce(function (item, _a) {
            var productId = _a.productId, quantity = _a.quantity, promotionId = _a.promotionId;
            var index = item.findIndex(function (i) { return productId === i.productId; });
            if (index === -1) {
                item.push({ productId: productId, quantity: quantity, promotion: [{ promotionID: promotionId[0], quantity: quantity }] });
            }
            else {
                item[index].promotion.push({ promotionID: promotionId[0], quantity: quantity });
                item[index] = ({ productId: productId, quantity: item[index].quantity + quantity, promotion: item[index].promotion });
            }
            return item;
        }, []);
        return products;
    };
    /**
     * To Set SubTotal, Total CC and CountryTax Inclusive option
     * @param subTotal
     * @param totalCC
     * @param countryTaxInclusive
     */
    CommonService.prototype.setSubTotalAndOrderCC = function (subTotal, totalCC, countryTaxInclusive) {
        this.itemSubTotal = subTotal,
            this.totalCC = totalCC;
        this.countryTaxInclusive = countryTaxInclusive;
    };
    /**
     * To Get Promotions based on store
     * @param storeId
     * @param request
     * @returns
     */
    CommonService.prototype.getPromotionEngineConfigurations = function (storeId, request) {
        var url = ApiUrlConstants.productApiUrl + '/v1/stores/' + storeId + '/promotion-engine/member';
        return this._http.post(url, request)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.depositFeeEnabledProducts = function (items) {
        var productsCount = 0;
        if (items && items.length) {
            productsCount = items.value.reduce(function (prev, p) {
                if (p.depositFeeEnabled) {
                    productsCount += 1;
                }
                return productsCount;
            }, 0);
        }
        return productsCount;
    };
    /**
     * To Get stock quantity available
     * @param product
     * @param  currentFreeProduct
     * @returns
     */
    CommonService.prototype.stockQuantityCheck = function (product, currentFreeProduct) {
        var stockQuantity = new StockQuantity();
        var stockBalanceQuantity = product.stockQuantity;
        stockQuantity.currentFreeProductQuantity = 0;
        stockQuantity.orderPromotionTrackings = [];
        currentFreeProduct.promotion.forEach(function (element) {
            if (product.stockAvailable && !product.manageStock) {
                stockQuantity.orderPromotionTrackings.push(element);
                stockQuantity.currentFreeProductQuantity += element.quantity;
            }
            else if (product.manageStock && stockBalanceQuantity > 0) {
                if (element.quantity >= stockBalanceQuantity) {
                    element.quantity = stockBalanceQuantity;
                    stockQuantity.orderPromotionTrackings.push(element);
                    stockBalanceQuantity = 0;
                    stockQuantity.currentFreeProductQuantity += element.quantity;
                }
                else {
                    stockBalanceQuantity = stockBalanceQuantity - element.quantity;
                    stockQuantity.orderPromotionTrackings.push(element);
                    stockQuantity.currentFreeProductQuantity += element.quantity;
                }
            }
        });
        return stockQuantity;
    };
    /**
     * Get Free Products from promotion and update quantity in cart if product exist
     * else add it to FreeProductAdd array
     * @param freeProducts
     * @param items
     * @param orderFormGroup
     * @param  promotionIds
     * @returns
     */
    CommonService.prototype.updateCartAfterPromotion = function (freeProducts, items, orderFormGroup, promotionIds) {
        var _this = this;
        var freeProductsToAdd = [];
        freeProducts.forEach(function (freeProductItem) {
            var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value ===
                freeProductItem.productId; });
            if (sameProductIndex >= 0) {
                var product = items.controls[sameProductIndex].controls['productItem'].value;
                var stockQuantity = _this.stockQuantityCheck(product, freeProductItem);
                if (stockQuantity.currentFreeProductQuantity > 0) {
                    if (freeProductItem.promotionId && freeProductItem.promotionId.length > 0) {
                        freeProductItem.promotionId.forEach(function (promotionId) {
                            if (promotionIds.indexOf(promotionId) == -1) {
                                promotionIds.push(promotionId);
                            }
                        });
                    }
                    freeProductItem.quantity = stockQuantity.currentFreeProductQuantity;
                    if (+items.controls[sameProductIndex].controls['quantity'].value < 999) {
                        items.controls[sameProductIndex].controls['quantity'].setValue(freeProductItem.quantity);
                        product.orderPromotionTrackings = stockQuantity.orderPromotionTrackings;
                        product.quantity = freeProductItem.quantity;
                        items.controls[sameProductIndex].controls['productItem'].setValue(product);
                        orderFormGroup.controls['itemSearch'].setValue('');
                    }
                }
            }
            else
                freeProductsToAdd.push(freeProductItem.productId);
        });
        return freeProductsToAdd;
    };
    /**
    * To  remove non promotion products
    * @param freeProductsInfo
    * @param  items
    */
    CommonService.prototype.removeNonPromotionProducts = function (freeProductsInfo, items) {
        if (freeProductsInfo && items) {
            var itemsToRemove = [];
            var _loop_1 = function (i) {
                var productId = items.controls[i].controls['productId'].value;
                var productItem = items.controls[i].controls['productItem'].value;
                var index = freeProductsInfo.findIndex(function (freeProduct) { return productId === freeProduct.productId; });
                if (index < 0 && productItem.orderPromotionTrackings && productItem.orderPromotionTrackings.length > 0) {
                    itemsToRemove.push(i);
                }
            };
            for (var i = 0; i < items.controls.length; i++) {
                _loop_1(i);
            }
            if (itemsToRemove.length > 0) {
                itemsToRemove = itemsToRemove.sort(function (a, b) { return b - a; });
                itemsToRemove.forEach(function (index) {
                    items.removeAt(index);
                });
            }
        }
    };
    /**
       * To  add the promotion item
       * @param  items
       * @param index
       * @param product
       * @param uiTemplateBaseUrl
       * @param cdnURL
       * @returns
       */
    CommonService.prototype.addPromoItem = function (items, index, product, uiTemplateBaseUrl, cdnURL) {
        var itemValue = product.itemNumber + ' - ' + product.name;
        items.controls[index].controls['itemNumber'].setValue(itemValue);
        var itemImage = (product.imageModelList && product.imageModelList.length > 0)
            ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
        var imageUrl = (itemImage && itemImage.url) ? (cdnURL + '/' + itemImage.url)
            : (uiTemplateBaseUrl + '/images/no_image.png');
        items.controls[index].controls['productImage'].setValue(imageUrl);
        items.controls[index].controls['productNumber'].setValue(product.itemNumber);
        items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
        items.controls[index].controls['productId'].setValue(product.id);
        product.promoProduct = true;
        items.controls[index].controls['productItem'].setValue(product);
        if (items.controls[index].controls['disableIncrement'])
            items.controls[index].controls['disableIncrement'].setValue(true);
        if (items.controls[index].controls['disableDecrement'])
            items.controls[index].controls['disableDecrement'].setValue(true);
        items.controls[index].controls['disableDelete'].setValue(true);
        return items;
    };
    /**
     * @date 2021-09-13
     * @returns To get country payment method source configuration
     */
    CommonService.prototype.getPaymentMethodsSourceConfiguration = function () {
        // const url = environment.uiTemplateBaseUrl + '/test/payment-method-source-configuration.json';
        var url = environment.cdnURL + '/portals/customercare/template1/schema-forms/payment-method-source-configuration.json';
        return this._http
            .get(url)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.filterPaymentMethods = function (paymentMethodSourceConfigurationData, paymentMethods, orderType) {
        var filteredPaymentMethods = paymentMethods;
        if (paymentMethodSourceConfigurationData && filteredPaymentMethods) {
            var removePaymentMethodIds_1 = [];
            filteredPaymentMethods.forEach(function (paymentMethod) {
                if (paymentMethod) {
                    var payment = paymentMethodSourceConfigurationData.paymentMethods.find(function (paymentMethodName) { return paymentMethodName.name === paymentMethod.paymentMethodName; });
                    if (payment && payment.allowedOrderflows) {
                        var isAllowedPaymentMethod = payment.allowedOrderflows.find(function (payment) { return payment === orderType; });
                        if (!isAllowedPaymentMethod) {
                            removePaymentMethodIds_1.push(paymentMethod.paymentMethodId);
                        }
                    }
                    else if (!payment) {
                        removePaymentMethodIds_1.push(paymentMethod.paymentMethodId);
                    }
                }
            });
            if (removePaymentMethodIds_1 && removePaymentMethodIds_1.length > 0) {
                removePaymentMethodIds_1.forEach(function (paymentMethodId) {
                    var index = filteredPaymentMethods.findIndex(function (paymentMethod) { return paymentMethod.paymentMethodId == paymentMethodId; });
                    if (index > -1) {
                        filteredPaymentMethods.splice(index, 1);
                    }
                });
            }
        }
        return filteredPaymentMethods;
    };
    CommonService.prototype.getLanguageCulture = function (storeInfo, isoThreeCountryCode, memberInfo) {
        var languageCulture = null;
        var countryLanguage = null;
        if (storeInfo && memberInfo && isoThreeCountryCode) {
            var memberHomeCountry = memberInfo.memberAllowedCountries
                .find(function (country) { return country.homeCountry === true; });
            if (memberHomeCountry && memberHomeCountry.isoCodeThree == isoThreeCountryCode) {
                var preference_1 = memberInfo.memberPreferences.find(function (preference) { return preference.preferenceId == MemberPreferenceType.PreferredCommunicationLanguage; });
                if (preference_1) {
                    countryLanguage = storeInfo.languages.find(function (countryLanguage) { return countryLanguage.languageCultureId == (+preference_1.preferenceValue); });
                    languageCulture = countryLanguage ? countryLanguage.languageCulture : '';
                }
            }
            if (!countryLanguage) {
                languageCulture = storeInfo.languages.find(function (languageCulture) { return languageCulture.default; }).cultureName;
            }
            return languageCulture;
        }
    };
    CommonService.prototype.getMemberLevel = function (memberLevelID) {
        var memberLevel;
        if (memberLevelID === MemberLevel.ASSISTANTSUPERVISOR) {
            memberLevel = UserTitleType.ASSISTANTSUPERVISOR;
        }
        else if (memberLevelID === MemberLevel.ASSISTANTMANAGER) {
            memberLevel = UserTitleType.ASSISTANTMANAGER;
        }
        else if (memberLevelID === MemberLevel.DIAMONDCENTURIONMANAGER) {
            memberLevel = UserTitleType.DIAMONDCENTURIONMANAGER;
        }
        else if (memberLevelID === MemberLevel.DIAMONDMANAGER) {
            memberLevel = UserTitleType.DIAMONDMANAGER;
        }
        else if (memberLevelID === MemberLevel.DIAMONDSAPPHIREMANAGER) {
            memberLevel = UserTitleType.DIAMONDSAPPHIREMANAGER;
        }
        else if (memberLevelID === MemberLevel.DOUBLEDIAMONDMANAGER) {
            memberLevel = UserTitleType.DOUBLEDIAMONDMANAGER;
        }
        else if (memberLevelID === MemberLevel.GUEST) {
            memberLevel = UserTitleType.GUEST;
        }
        else if (memberLevelID === MemberLevel.MANAGER) {
            memberLevel = UserTitleType.MANAGER;
        }
        else if (memberLevelID === MemberLevel.NOVICCUSTOMER) {
            memberLevel = UserTitleType.NOVICCUSTOMER;
        }
        else if (memberLevelID === MemberLevel.PREFERREDCUSTOMER) {
            memberLevel = UserTitleType.PREFERREDCUSTOMER;
        }
        else if (memberLevelID === MemberLevel.RECOGNIZEDMANAGER) {
            memberLevel = UserTitleType.RECOGNIZEDMANAGER;
        }
        else if (memberLevelID === MemberLevel.RETAIL) {
            memberLevel = UserTitleType.RETAIL;
        }
        else if (memberLevelID === MemberLevel.SAPPHIREMANAGER) {
            memberLevel = UserTitleType.SAPPHIREMANAGER;
        }
        else if (memberLevelID === MemberLevel.SENIORMANAGER) {
            memberLevel = UserTitleType.SENIORMANAGER;
        }
        else if (memberLevelID === MemberLevel.SOARINGMANAGER) {
            memberLevel = UserTitleType.SOARINGMANAGER;
        }
        else if (memberLevelID === MemberLevel.SUPERVISOR) {
            memberLevel = UserTitleType.SUPERVISOR;
        }
        else if (memberLevelID === MemberLevel.TRIPLEDIAMONDMANAGER) {
            memberLevel = UserTitleType.TRIPLEDIAMONDMANAGER;
        }
        else if (memberLevelID === MemberLevel.UNRECOGNIZEDMANAGER) {
            memberLevel = UserTitleType.UNRECOGNIZEDMANAGER;
        }
        return memberLevel;
    };
    CommonService.prototype.getMemberAllowedCountries = function (memberId) {
        var url = ApiUrlConstants.accountApiUrl + 'members/' + memberId + '/allowed-countries';
        return this._http
            .get(url)
            .map(function (res) { return res.json(); })
            .catch(this.handleErrorObservable);
    };
    CommonService.prototype.mapTransliterateProperties = function (storeDetails, languageCultureName) {
        return {
            enableTransliterate: storeDetails && storeDetails.enableTransliteration ? true : false,
            languageCode: languageCultureName ? languageCultureName : null
        };
    };
    CommonService.prototype.hasStoreEnabledTransliteration = function (storeData) {
        return (storeData && storeData.enableTransliteration) ? true : false;
    };
    CommonService.prototype.getMemberPrefferedLanguage = function (memberDetails, storeInfo) {
        var languageCode = '';
        var webSitelanguagePreference = memberDetails && !!Object.keys(memberDetails).length && memberDetails.memberPreferences && !!memberDetails.memberPreferences.length && memberDetails.memberPreferences.find(function (x) { return x.preferenceId === MemberPreferencesType.PREFERREDWEBSITELANGUAGE; });
        var language = webSitelanguagePreference && storeInfo && storeInfo.languages && !!storeInfo.languages.length && storeInfo.languages.find(function (x) { return x.languageId === parseInt(webSitelanguagePreference.preferenceValue, 0); });
        languageCode = language && language.cultureName;
        if (!languageCode) {
            languageCode = this.getStoreDefaultLanguage(storeInfo);
        }
        return languageCode;
    };
    CommonService.prototype.getStoreDefaultLanguage = function (storeInfo) {
        var storeDefaultLanguage = '';
        if (storeInfo && storeInfo.languages && !!storeInfo.languages.length) {
            var language = storeInfo.languages.find(function (x) { return x.default; });
            storeDefaultLanguage = language && language.cultureName;
        }
        return storeDefaultLanguage;
    };
    CommonService.prototype.getPaymentTypeLabel = function (pymtType) {
        switch (pymtType) {
            case PaymentMethodTypes.Credit_Card:
                pymtType = PaymentMethodTypeConstants.Credit_Card;
                break;
            case PaymentMethodTypes.eCheck:
                pymtType = PaymentMethodTypeConstants.eCheck;
                break;
            case PaymentMethodTypes.Money_order:
                pymtType = PaymentMethodTypeConstants.Money_Order;
                break;
            case PaymentMethodTypes.Wire_Transfer:
                pymtType = PaymentMethodTypeConstants.Wire_Transfer;
                break;
            case PaymentMethodTypes.Cash:
                pymtType = PaymentMethodTypeConstants.Cash;
                break;
            case PaymentMethodTypes.Ideal:
                pymtType = PaymentMethodTypeConstants.Ideal;
                break;
            case PaymentMethodTypes.PayPal:
                pymtType = PaymentMethodTypeConstants.Paypal;
                break;
            case PaymentMethodTypes.Cash_On_Delivery:
                pymtType = PaymentMethodTypeConstants.Cash_On_Delivery;
                break;
            case PaymentMethodTypes.Bank_Transfer:
                pymtType = PaymentMethodTypeConstants.Bank_Transfer;
                break;
            case PaymentMethodTypes.Integrated_Terminal_Adyen:
                pymtType = PaymentMethodTypeConstants.Integrated_Terminal_Adyen;
                break;
            case PaymentMethodTypes.Pay_By_Link:
                pymtType = PaymentMethodTypeConstants.Pay_By_Link;
                break;
            case PaymentMethodTypes.Single_Debit:
                pymtType = PaymentMethodTypeConstants.Single_Debit;
                break;
            case PaymentMethodTypes.Direct_Debit:
                pymtType = PaymentMethodTypeConstants.Direct_Debit;
                break;
            case PaymentMethodTypes.Credit_Card_External:
                pymtType = PaymentMethodTypeConstants.Credit_Card_External;
                break;
            case PaymentMethodTypes.Giro_Pay:
                pymtType = PaymentMethodTypeConstants.Giro_Pay;
                break;
            case PaymentMethodTypes.Blik:
                pymtType = PaymentMethodTypeConstants.Blik;
                break;
            case PaymentMethodTypes.Eps:
                pymtType = PaymentMethodTypeConstants.Eps;
                break;
            case PaymentMethodTypes.MisterCash_and_Maestro:
                pymtType = PaymentMethodTypeConstants.MisterCash_and_Maestro;
                break;
            case PaymentMethodTypes.BanContact_MisterCash_and_Maestro:
                pymtType = PaymentMethodTypeConstants.BanContact_MisterCash_and_Maestro;
                break;
            case PaymentMethodTypes.Orange_Money:
                pymtType = PaymentMethodTypeConstants.Orange_Money;
                break;
            case PaymentMethodTypes.Wave:
                pymtType = PaymentMethodTypeConstants.Wave;
                break;
            case PaymentMethodTypes.Personal_Check:
                pymtType = PaymentMethodTypeConstants.Personal_Check;
                break;
            case PaymentMethodTypes.Ach:
                pymtType = PaymentMethodTypeConstants.Ach;
                break;
            case PaymentMethodTypes.Bonus_Check:
                pymtType = PaymentMethodTypeConstants.Bonus_Check;
                break;
            case PaymentMethodTypes.Travelers_Check:
                pymtType = PaymentMethodTypeConstants.Travelers_Check;
                break;
            case PaymentMethodTypes.Google_Pay:
                pymtType = PaymentMethodTypeConstants.Google_Pay;
                break;
            case PaymentMethodTypes.Apple_Pay:
                pymtType = PaymentMethodTypeConstants.Apple_Pay;
                break;
            case PaymentMethodTypes.Walley:
                pymtType = PaymentMethodTypeConstants.Walley;
                break;
            case PaymentMethodTypes.Twint:
                pymtType = PaymentMethodTypeConstants.Twint;
                break;
            case PaymentMethodTypes.Riverty:
                pymtType = PaymentMethodTypeConstants.Riverty;
                break;
            case PaymentMethodTypes.ApplePay_Adyen:
                pymtType = PaymentMethodTypeConstants.ApplePay_Adyen;
                break;
            case PaymentMethodTypes.GooglePay_Adyen:
                pymtType = PaymentMethodTypeConstants.GooglePay_Adyen;
                break;
            default:
                pymtType = PaymentMethodTypeConstants.Credit_Card;
                break;
        }
        return pymtType;
    };
    CommonService.prototype.applyPromotionFreeShipping = function (shippingMethods, promotionModels, items, totalCC) {
        if (promotionModels && promotionModels.length) {
            for (var _i = 0, promotionModels_1 = promotionModels; _i < promotionModels_1.length; _i++) {
                var promotion = promotionModels_1[_i];
                if (promotion.promotionRewardTypeId && promotion.promotionRewardTypeId === PromotionRewardTypeEnum.Free_Shipping
                    && !(promotion.promotionSingleUse && promotion.redemptionUsageCount > 0)) {
                    var promotionShippingMethodIds = promotion.shippingMethods && promotion.shippingMethods.split(",");
                    if (promotionShippingMethodIds && promotionShippingMethodIds.length) {
                        // Free shipping eligible check
                        var freeShippingEligible = this.promotionEligiblityCheck(promotion, totalCC, items);
                        if (freeShippingEligible) {
                            this.applyFreeShipping(shippingMethods, promotionShippingMethodIds, promotion);
                        }
                    }
                }
            }
        }
    };
    CommonService.prototype.applyFreeShipping = function (shippingMethods, promotionShippingMethodIds, promotion) {
        if (shippingMethods && shippingMethods.length && promotionShippingMethodIds) {
            shippingMethods.forEach(function (shippingMethod) {
                if (promotionShippingMethodIds.includes(shippingMethod.shippingMethodId + "") && !shippingMethod.freeShippingEligible) {
                    shippingMethod.originalShippingCost = shippingMethod.shippingCharge ? shippingMethod.shippingCharge : 0;
                    shippingMethod.freeShippingEligible = true;
                    shippingMethod.shippingCharge = 0;
                    shippingMethod.shippingTax = 0;
                    shippingMethod.promotionId = promotion && promotion.promotionId ? promotion.promotionId : null;
                }
            });
        }
    };
    CommonService.prototype.promotionEligiblityCheck = function (promotion, totalCC, items) {
        var eligible = false;
        if (promotion.promotionActionTypeId == PromotionActionType.ORDER) {
            eligible = true;
        }
        else if (promotion.promotionActionTypeId == PromotionActionType.ORDERCC) {
            if (totalCC && promotion.ccValueCap && totalCC >= promotion.ccValueCap) {
                eligible = true;
            }
        }
        else if (promotion.promotionActionTypeId == PromotionActionType.PRODUCT && items && items.length) {
            var productIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === promotion.qualifyingProductId; });
            if (productIndex >= 0) {
                eligible = true;
            }
        }
        return eligible;
    };
    CommonService.prototype.singleOrDirectDebitCardEligibilityCheck = function (response, countryCode, homeCountryCode) {
        if (response != null && countryCode != null && homeCountryCode != null) {
            var hasSingleOrDirectDebit = response.some(function (x) {
                return x.paymentMethodName === PaymentMethodTypes.Single_Debit ||
                    x.paymentMethodName === PaymentMethodTypes.Direct_Debit;
            });
            if (hasSingleOrDirectDebit && countryCode.toLowerCase() !== homeCountryCode.toLowerCase()) {
                return response.filter(function (x) {
                    return !(x.paymentMethodName === PaymentMethodTypes.Single_Debit ||
                        x.paymentMethodName === PaymentMethodTypes.Direct_Debit);
                });
            }
        }
        return response;
    };
    return CommonService;
}());
export { CommonService };



// WEBPACK FOOTER //
// ./src/app/shared/services/common.service.ts.pre-build-optimizer.js